import identity from '../data/siteIdentity.json';

// Metadata normalization only. This never navigates, rewrites, or renames routes.
export function canonicalUrl(path = '/') {
  const url = new URL(path, identity.url);
  if (url.origin !== identity.url) return url.href;
  if (!url.pathname.endsWith('/') && !/\.[a-z0-9]+$/i.test(url.pathname)) {
    url.pathname += '/';
  }
  return url.href;
}

export function normalizeSchemaUrls(value, key = '') {
  if (Array.isArray(value)) return value.map(item => normalizeSchemaUrls(item, key));
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([name, item]) => [name, normalizeSchemaUrls(item, name)]));
  }
  if (typeof value === 'string' && ['@id', 'url', 'item', 'mainEntityOfPage'].includes(key)
      && (value === identity.url || value.startsWith(identity.url + '/'))) {
    return canonicalUrl(value);
  }
  return value;
}
